import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DataObjectIcon from '@mui/icons-material/DataObject';
import CodeOffIcon from '@mui/icons-material/CodeOff';

import { ResolvableModeEnum } from '@e-socna/data-layer';

import { DEFAULT_MODE } from './constants/default-mode.constant';
import type { ResolvableFieldProps } from './types/props.type';

export const FieldAdornment = ({
  name,
  onOpen: handleOpen,
  onSwitchToDefaultStatic: handleSwitchToDefaultStatic,
  value,
}: Readonly<Pick<ResolvableFieldProps, 'name' | 'value'>> &
  Readonly<{
    onOpen: () => void;
    onSwitchToDefaultStatic: () => void;
  }>) => {
  const currentMode = value?.mode ?? DEFAULT_MODE;

  const label =
    currentMode === ResolvableModeEnum.Dynamic
      ? 'Passer le champ en mode Statique'
      : 'Passer le champ en mode Dynamique';

  const icon =
    currentMode === ResolvableModeEnum.Dynamic ? (
      <CodeOffIcon />
    ) : (
      <DataObjectIcon />
    );

  const toggleAction =
    currentMode === ResolvableModeEnum.Dynamic
      ? handleSwitchToDefaultStatic
      : handleOpen;

  return (
    <Tooltip title={label}>
      <IconButton
        aria-label={label}
        id={`${name}-mode-toggle`}
        onClick={toggleAction}
        sx={{ mt: 1 }}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};
